<template>
  <main class="row q-gutter-x-xs">
    <section class="col q-mr-md">
      <span
        class="text-weight-bolder"
        style="display: block; font-size: 16px; color: #21324a"
        >Centros de custo.</span
      >
      <span style="display: block; color: #21324a"
        >Centros de custo disponíveis para vincular ao usuário.</span
      >

      <q-table
        flat
        sticky-header
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        dense
        v-model:pagination="pagination"
        class="q-mt-md my-sticky-header-table"
        hide-bottom
        color="primary"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
        @request="handleRequest"
      >
        <template v-slot:top-left>
          <lista-unidades-select
            style="margin-left: -15px"
            :todos="true"
            v-model="unidadeSelected"
          ></lista-unidades-select>
        </template>

        <template v-slot:top-right>
          <section class="row justify-between">
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              v-model="filtrar"
              type="text"
              placeholder="Pesquisar"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </section>
        </template>

        <template #body-cell-requisitante="props">
          <q-td>
            <div class="row col-12 justify-center">
              <q-btn
                v-if="props"
                color="secondary"
                flat
                icon="sym_o_add"
                no-caps
                round
                @click="adicionarRequisitante(props.row.id)"
              />
            </div>
          </q-td>
        </template>
        <template #body-cell-aprovador="props">
          <q-td>
            <div class="row col-12 justify-center">
              <q-btn
                v-if="props"
                color="positive"
                flat
                icon="sym_o_add"
                round
                no-caps
                @click="adicionarAprovador(props.row.id)"
              />
            </div>
          </q-td>
        </template>
      </q-table>
    </section>
    <q-separator vertical />
    <section class="col q-ml-md">
      <q-table
        style="height: 500px; margin-top: 61px; position: sticky"
        flat
        sticky-header
        dense
        table-header-class="bg-accent text-width-bold"
        :rows="rows2"
        :loading="disable"
        :columns="columns2"
        hide-bottom
        class="q-mt-md my-sticky-header-table"
        row-key="id"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
        :filter="filtrar2"
      >
        <template v-slot:top-left>
          <span style="display: block; margin-left: -15px; color: #21324a"
            >Centros de custo vinculados ao usuário.</span
          >
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar2"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <template #body-cell-nome="props">
          <q-td>
            {{ props.row.name }}
          </q-td>
        </template>
        <template #body-cell-aprovador="props">
          <q-td>
            <span v-if="props.row.pivot.approver == 1">SIM</span>
            <span v-else>NÃO</span>
          </q-td>
        </template>
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              v-if="props"
              color="negative"
              flat
              icon="sym_o_delete"
              round
              @click="deletarCentro(props.row.id)"
            />
          </q-td>
        </template>
      </q-table>
    </section>
  </main>
</template>

<script setup>
const columns = [
  {
    name: "code",
    label: "Código",
    field: "id",
    align: "left",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "vendor",
    label: "Unidade",
    field: (row) => row.vendor.name,
    align: "left",
  },
  {
    name: "requisitante",
    label: "Add. Req",
    field: "email",
    align: "left",
  },
  {
    name: "aprovador",
    label: "Add. Aprovador",
    field: "email",
    align: "left",
  },
];

const columns2 = [
  {
    name: "code",
    label: "Código",
    field: "id",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "vendor",
    label: "Unidade",
    field: (row) => row.vendor.name,
    align: "left",
  },
  {
    name: "aprovador",
    label: "Aprovador",
    field: (row) => row.pivot.approver,
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "email",
    align: "center",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { defineProps } from "vue";
import { ref, onMounted, computed, watch } from "vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
const store = useStore();
const disable = ref(true);
const rows = ref([]);
const rows2 = ref([]);
const unidadeSelected = ref();
const filtrar = ref("");
const filtrar2 = ref("");
const quasar = useQuasar();

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 15,
});

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);

const getCentros = async (page = 0, rowsPerPage = 15) => {
  disable.value = true;
  try {
    let response = await store.dispatch("user/getCentros", {
      vendor_id: store.state.org.unidadeData.id,
      page,
      per_page: rowsPerPage,
      search: filtrar.value,
    });

    rows.value = response.data.results.data;

    pagination.value.page = response.data.results.current_page;
    pagination.value.rowsPerPage = response.data.results.per_page;
    pagination.value.rowsNumber = response.data.results.total;

    disable.value = false;
  } catch (error) {
    quasar.notify({
      message: "Erro a o procurar dados",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

onMounted(getCentros);

const getCentrosAssociados = async () => {
  disable.value = true;

  try {
    let response = await store.dispatch("user/getUserEspecifico", {
      id: userId.value,
    });

    rows2.value = response.data.model.cost_centers;
    disable.value = false;
  } catch (error) {
    quasar.notify({
      message: "Erro a o procurar dados",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

onMounted(getCentrosAssociados);

const deletarCentro = async (center_id) => {
  try {
    await store.dispatch("user/deletarCentro", {
      id: userId.value,
      center_id,
    });

    getCentros();
    getCentrosAssociados();
  } catch (error) {
    quasar.notify({
      message: "Erro a o remover centro",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const adicionarAprovador = async (id_centro) => {
  try {
    let objeto = [{ cost_center_id: id_centro, approver: 1 }];

    await store.dispatch("user/adicionarAprovadorRequisitante", {
      id: userId.value,
      cost_centers: objeto,
    });

    getCentros();
    getCentrosAssociados();
  } catch (error) {
    quasar.notify({
      message: "Erro a o remover centro",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const adicionarRequisitante = async (id_centro) => {
  try {
    let objeto = [{ cost_center_id: id_centro, approver: 0 }];

    await store.dispatch("user/adicionarAprovadorRequisitante", {
      id: userId.value,
      cost_centers: objeto,
    });

    getCentros();
    getCentrosAssociados();
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro a o remover centro",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const handleRequest = async (props) => {
  getCentros(props.pagination.page, props.pagination.rowsPerPage);
};

const getUnidade = () => {
  if (
    localStorage.unidade &&
    localStorage.unidade != null &&
    localStorage.unidade != "null"
  ) {
    let getunidade = localStorage.getItem("unidade");
    unidadeSelected.value = JSON.parse(getunidade);
  }
};

onMounted(getUnidade);
watch(
  () => store.state.org.unidadeData,
  () => {
    getCentros();
    getCentrosAssociados();
  }
);
watch(
  () => filtrar.value,
  () => {
    getCentros();
  }
);

watch(
  () => store.state.org.unidadeData.id,
  () => {
    getCentros();
  }
);
</script>

<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  max-height: 500px


  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #EEF3FE

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
